/** @format */

// Dropdown Component

import React, { useState, useRef, useEffect } from "react";
import imgArrowDropdown from "../../assets/IconDrop.png";
import "../../css/Dropdown.css";

export default function DropdownOrg(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   if (selectedOption) {
  //     props.onSelect(selectedOption);
  //   }
  // }, [selectedOption]);

  useEffect(() => {
    if (props.selectedOption) {
      setSelectedOption(props.selectedOption);
    }
  }, [props.selectedOption]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    props.onSelect(option);
    toggleDropdown();
  };

  const getDropdownWidth = () => {
    return dropdownRef.current?.offsetWidth || 0;
  };

  return (
    <div className="dropdown-container">
      <div
        className={`dropdown-header ${selectedOption ? "selected" : ""} ${
          isOpen ? "open" : ""
        }`}
        onClick={toggleDropdown}>
        {selectedOption ? (
          <img className="img-logo" src={selectedOption.photo} />
        ) : null}

        <p
          className={`${
            selectedOption ? "org-dropdown-selected" : "dropdown-not-select"
          }`}>
          {selectedOption ? selectedOption.name : props.placeholder}
        </p>

        <img className="img-dropdown" src={imgArrowDropdown}></img>
      </div>

      {props.options != undefined ? (
        <div
          className={`dropdown-list ${isOpen ? "open" : ""}`}
          style={{ width: getDropdownWidth() }}
          ref={dropdownRef}>
          {props.options.map((option) => (
            <div
              key={option.id}
              className="dropdown-option"
              onClick={() => handleOptionClick(option)}>
              <img src={option.photo} />
              <p>{option.name}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
